import { useState, useCallback } from "react";

/**
 * OPTIMISTIC UI UPDATES
 * Update UI immediately, rollback on error
 */
export const useOptimisticUpdate = () => {
  const [rollbackStack, setRollbackStack] = useState([]);

  const optimisticUpdate = useCallback(
    async ({
      updateFn, // Function to update UI
      apiFn, // API call
      rollbackFn, // Function to rollback on error
      onSuccess, // Success callback
      onError, // Error callback
    }) => {
      // Apply optimistic update
      updateFn();

      try {
        // Make API call
        const result = await apiFn();

        // Success callback
        if (onSuccess) onSuccess(result);

        return { success: true, data: result };
      } catch (error) {
        // Rollback on error
        if (rollbackFn) rollbackFn();

        // Error callback
        if (onError) onError(error);

        return { success: false, error };
      }
    },
    []
  );

  return { optimisticUpdate };
};





